<template>
	<vs-sidebar
		click-not-close
		position-right
		parent="body"
		default-index="1"
		color="primary"
		class="add-new-data-sidebar items-no-padding"
		spacer
		v-model="isSidebarActiveLocal"
	>
		<div class="mt-6 flex items-center justify-between px-6">
			<h4 class="uppercase">
				{{ Object.entries(this.data).length === 0 ? $t("Status.CreateStatus") : $t("Status.UpdateStatus") }}
			</h4>
			<feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
		</div>
		<vs-divider class="mb-0"></vs-divider>

		<component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
			<div class="p-6">
				<StatusForm
					:data="company"
					:isEditActive="true"
					v-if="isSidebarActiveLocal"
					@closeSidebar="toggleDataSidebar"
				/>
			</div>
		</component>
	</vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleStatus from "@/store/status/moduleStatus.js";
import DateUtils from "@/helpers/DateUtils.js";

import StatusForm from "@/components/status/StatusForm.vue";
import Company from "@/models/Company.js";

export default {
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true,
		},
		data: {
			type: Object,
		},
	},
	components: {
		VuePerfectScrollbar,
		StatusForm,
	},
	data() {
		return {
			company: new Company({}),
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
		};
	},
	created() {
		if (!moduleStatus.isRegistered) {
			this.$store.registerModule("moduleStatus", moduleStatus);
			moduleStatus.isRegistered = true;
		}
	},
	watch: {
		isSidebarActive(val) {
			if (!val) return;
			if (Object.entries(this.data).length === 0) {
				this.initValues();
				this.$validator.reset();
			} else {
				this.company = this.data;
			}
			// Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
		},
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			},
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
		today() {
			const f = new Date("Tue, 18 Mar 2025 19:35:52 GMT");
			return DateUtils.toDefaultDateTime(f, "YYYY-MM-DD");
		},
	},
	methods: {
		toggleDataSidebar(val = false) {
			this.$emit("closeSidebar");
		},
	},
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
	::v-deep .vs-sidebar--background {
		z-index: 52010;
	}

	::v-deep .vs-sidebar {
		z-index: 52010;
		width: 400px;
		max-width: 90vw;

		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}

.scroll-area--data-list-add-new {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

	&:not(.ps) {
		overflow-y: auto;
	}
}
</style>
